import type { ApiResponse, UserInfoResponse } from "../../../shared/types/api";
import { httpClient } from "../http-client";
import { NEW_API_ENDPOINTS } from "../../../shared/constants/api";
import type { Department } from "../../../domain/types/department";

export class DepartmentApiService {
  async getDepartments(companyId: number): Promise<ApiResponse<Department[]>> {
    const response = await httpClient.get<ApiResponse<Department[]>>(
      NEW_API_ENDPOINTS.companyDepartmentController.GET(companyId),
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "부서 목록을 가져오지 못했습니다.");
    }

    return response.data;
  }

  async createDepartment(
    companyId: number,
    name: string,
  ): Promise<ApiResponse<Department>> {
    const response = await httpClient.post<ApiResponse<Department>>(
      NEW_API_ENDPOINTS.companyDepartmentController.POST(companyId),
      { name },
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "부서 생성에 실패했습니다.");
    }

    return response.data;
  }

  async updateDepartment(
    companyId: number,
    departmentId: number,
    name: string,
  ): Promise<ApiResponse<Department>> {
    const response = await httpClient.put<ApiResponse<Department>>(
      NEW_API_ENDPOINTS.companyDepartmentController.PUT(companyId, departmentId),
      { name },
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "부서 수정에 실패했습니다.");
    }

    return response.data;
  }

  async reorderDepartments(
    companyId: number,
    departmentIds: number[],
  ): Promise<ApiResponse<Department[]>> {
    const response = await httpClient.put<ApiResponse<Department[]>>(
      NEW_API_ENDPOINTS.companyDepartmentController.PUT_REORDER(companyId),
      { departmentIds },
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "부서 순서 변경에 실패했습니다.");
    }

    return response.data;
  }

  async deleteDepartment(
    companyId: number,
    departmentId: number,
  ): Promise<ApiResponse<void>> {
    const response = await httpClient.delete<ApiResponse<void>>(
      NEW_API_ENDPOINTS.companyDepartmentController.DELETE(companyId, departmentId),
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "부서 삭제에 실패했습니다.");
    }

    return response.data;
  }
  async assignMembers(
    companyId: number,
    departmentId: number,
    userIds: number[],
  ): Promise<ApiResponse<UserInfoResponse[]>> {
    const response = await httpClient.post<ApiResponse<UserInfoResponse[]>>(
      NEW_API_ENDPOINTS.companyDepartmentController.POST_MEMBERS(companyId, departmentId),
      { userIds },
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "부서 회원 배정에 실패했습니다.");
    }

    return response.data;
  }

  async removeMember(
    companyId: number,
    departmentId: number,
    userId: number,
  ): Promise<ApiResponse<boolean>> {
    const response = await httpClient.delete<ApiResponse<boolean>>(
      NEW_API_ENDPOINTS.companyDepartmentController.DELETE_MEMBER(companyId, departmentId, userId),
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "부서 회원 제거에 실패했습니다.");
    }

    return response.data;
  }
}

export const departmentApiService = new DepartmentApiService();